import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LeagueWeek } from '../../../models/LeagueWeek';
import { Player } from '../../../models/Player';
import { GolfEventService } from '../../../services/golf-event.service';
import { NgFor, NgIf } from '@angular/common';
import { GolfEventField } from '../../../models/golfeventfield';
import { PostIndividualRoundComponent } from './post-individual-round/post-individual-round.component';

@Component({
  selector: 'app-weekly-round-list',
  standalone: true,
  imports: [NgFor, NgIf, PostIndividualRoundComponent],
  templateUrl: './weekly-round-list.component.html',
  styleUrl: './weekly-round-list.component.css'
})
export class WeeklyRoundListComponent implements OnChanges {
  @Input() leagueWeek:LeagueWeek|null = null;
  @Input() loggedInPlayerId:number|null = null;
  @Input() loggedInPlayerHasPaid:boolean = false;
  @Input() paidPlayers:Array<GolfEventField> = [];

  constructor(private golfEventService:GolfEventService) {}

  players:Array<Player> = [];
  containerDisplay:string = 'ROUNDLIST'

  ngOnChanges(changes: SimpleChanges) {
    if (changes['leagueWeek'] && changes['leagueWeek'].currentValue) {
      this.getRounds();
    }
  }

  async getRounds(){
    if(!this.leagueWeek) return;
    
  }

  postRound():void {
    //Individual or Team league?
    this.containerDisplay = 'POSTINDIVIDUALROUND';
  }

  scoresPosted(): void {
    this.getRounds();
    this.containerDisplay = 'ROUNDLIST'
  }
}

